import { Error404Page, Landing } from 'features/misc';
import { useRoutes } from 'react-router-dom';

export const AppRoutes = () => {
  const commonRoutes = [
    { path: '/', element: <Landing /> },

    { path: '*', element: <Error404Page /> },
  ];

  const element = useRoutes([...commonRoutes]);

  return <>{element}</>;
};
